<template>
    <div class="p-3 bg-info rounded">
        <slot name="header" />

        <div
            :class="[{ 'is-editable': isEditable }, 'note-body']"
        >
            <slot name="body" />
        </div>

        <div class="d-flex align-items-end justify-content-between">
            <button
                @click="toggle"
                class="btn btn-primary mt-3"
            >
                <template v-if="isEditable">
                    Opslaan
                </template>
                <ui-icon
                    v-else
                    icon="edit"
                    class="m-0"
                />
            </button>

            <slot name="footer" />
        </div>
    </div>
</template>

<script>
import UiIcon from './icon.vue';

export default {
    name: 'UiNote',
    components: {
        UiIcon,
    },
    data() {
        return {
            isEditable: false,
        };
    },
    methods: {
        toggle(e) {
            if (!this.isEditable) {
                e.preventDefault();

                this.isEditable = !this.isEditable;
            }
        },
    },
}
</script>

<style lang="scss">
    .note-body:not(.is-editable) {
        .form-control {
            padding: 0;
            pointer-events: none;
            background-color: transparent;
            border: 0;
        }
    }
</style>
